import { useEffect, useState } from 'react'

/** Contatore di persone che stanno guardando la pagina, con piccole oscillazioni. */
export function useLiveViewers(initial = 27): number {
  const [viewers, setViewers] = useState(initial)

  useEffect(() => {
    const id = window.setInterval(() => {
      setViewers((current) => {
        const next = current + (Math.random() > 0.5 ? 1 : -1) * (1 + Math.floor(Math.random() * 2))
        return Math.min(48, Math.max(18, next))
      })
    }, 4200)
    return () => window.clearInterval(id)
  }, [])

  return viewers
}
